<section class="activation-link-expired">
  <h2 class="activation-link-expired__title">
    {{ 'activation-link-expired.title' | translate }}
  </h2>

  <app-mui-button
    class="activation-link-expired__mui-button"
    variant="contained"
    color="primary"
    size="large"
    (click)="onResendVerificationLink()">
    {{ 'buttons.resend-activation-link' | translate }}
  </app-mui-button>
</section>
